import { API_BASE_URL } from './apiConfig';
import { handleUnauthorized } from './authApi';

const headers = () => {
  const token = sessionStorage.getItem('casapizza_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const fetchAdminCatalog = async (branchId = null) => {
  const url = branchId
    ? `${API_BASE_URL}/admin/catalog?branch_id=${branchId}`
    : `${API_BASE_URL}/admin/catalog`;
  const res = await fetch(url, { headers: headers() });
  if (!res.ok) {
    if (res.status === 401) handleUnauthorized();
    throw new Error('Error al cargar catálogo');
  }
  return res.json();
};

export const setBranchOverride = async (productType, itemId, branchId, active) => {
  const res = await fetch(
    `${API_BASE_URL}/admin/catalog/${productType}/${itemId}/branch/${branchId}`,
    { method: 'PUT', headers: headers(), body: JSON.stringify({ active }) }
  );
  if (!res.ok) {
    if (res.status === 401) handleUnauthorized();
    throw new Error('Error al actualizar override');
  }
  return res.json();
};

export const updateCatalogItem = async (type, id, data) => {
  const res = await fetch(`${API_BASE_URL}/admin/catalog/${type}/${id}`, {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    if (res.status === 401) handleUnauthorized();
    throw new Error('Error al actualizar');
  }
  return res.json();
};

export const createCatalogItem = async (type, data) => {
  const res = await fetch(`${API_BASE_URL}/admin/catalog/${type}`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    if (res.status === 401) handleUnauthorized();
    throw new Error('Error al crear');
  }
  return res.json();
};
